
import { getTaskStationList, getStationPublishingDeviceList } from '@/api/order/demand'

export const screenSetMixins = {
  data () {
    return {
    }
  },
  methods: {
    getStationData () {
      getTaskStationList({ demandMainId: this.curTaskId }).then(res => {
        if (res && !res.errcode) {
          this.stationArray = res
          this.showStationArray = res
          this.handleChoiceItem(this.showStationArray[0])
          if (this.stationArray.length) {
            this.stationArray.forEach(item => {
              if (!this.assetArray.some(s => s.assetId === item.assetId)) {
                this.assetArray.push({ assetId: item.assetId, assetName: item.assetName })
              }
            })
          }
        } else {
          this.stationArray = []
        }
      })
    },
    getPublishingData () {
      // let postSvgData = []
      this.deviceInfoArray = []
      getStationPublishingDeviceList({ stationId: this.curStationId, demandMainId: this.curTaskId, floors: JSON.stringify(this.floors) }).then(res => {
        this.deviceInfoArray = res
      }).finally(() => {
        this.$refs.svgStation.existScreenDevice(this.deviceInfoArray)
      })
    },
    handleChangeAsset () {
      this.showStationArray = this.assetId ? this.stationArray.filter(x => x.assetId === this.assetId) : this.stationArray
      if (this.showStationArray.length) {
        this.handleChoiceItem(this.showStationArray[0])
      }
    },
    handleChoiceItem (obj) {
      this.curStation = obj
      this.stationSvgInit()
    },
    stationSvgInit () {
      this.curStationId = this.curStation ? this.curStation.stationId : -1
      this.floors = this.curStation.floorList
      this.$nextTick(() => {
        this.$refs.svgStation.initData()
      })
    }

  }
}
